// Month-first and day-first numeric forms are mutually ambiguous (9/10/2026), so a field only ever
// gets the family matching its display format. Named-month and ISO forms are unambiguous either way.
const UNAMBIGUOUS_FORMATS = ['MMM D, YYYY', 'MMM D YYYY', 'YYYY-MM-DD'];
const MONTH_FIRST_FORMATS = ['MM/DD/YYYY', 'M/D/YYYY'];
const DAY_FIRST_FORMATS = ['DD/MM/YYYY', 'D/M/YYYY'];

/**
 * The formats an antd date picker should accept for typed input, given the format it displays in.
 * rc-picker parses typed text strictly against each format in order and displays in the first, so
 * the display format leads and the common alternatives follow. A day-first display (`DD/MM/YYYY`)
 * gets day-first numeric alternatives; every other display gets month-first ones.
 * @param {string} displayFormat - The moment format the field displays dates in.
 * @returns {string[]} The display format followed by the accepted alternatives, without duplicates.
 * @example
 * <DatePicker format={acceptedDateFormats('MM/DD/YYYY')} />
 */
export const acceptedDateFormats = (displayFormat: string): string[] => {
  const numeric = displayFormat.startsWith('D') ? DAY_FIRST_FORMATS : MONTH_FIRST_FORMATS;
  return Array.from(new Set([displayFormat, ...numeric, ...UNAMBIGUOUS_FORMATS]));
};
